//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  head: function () {
    return {
      link: [
        {rel: 'preload', as: 'image', href: this.imageUrlPlaceholder},
      ]
    }
  },

  props: {
    imageId: {
      type: String,
      default: ""
    },
  },

  computed: {
    mainImageSize: function () {
      const isServer = Boolean(process.server);
      if (isServer) {
        return {width: 766, height: 383};
      }

      if (window.innerWidth >= 1024) {
        return {width: 766, height: 383};
      }

      let _width = (window.innerWidth || 0) - 16;
      if (window.innerWidth >= 990) {
        _width = _width - 48;
      }
      if (window.innerWidth < 990 && window.innerWidth >= 660) {
        _width = _width - 32;
      }
      if (window.innerWidth < 660) {
        _width = _width - 16;
      }

      return {
        width: _width,
        height: _width / 2
      }
    },
    imageUrlPlaceholder: function () {
      return this.$img(this.imageId, {
        width: 766,
        height: 383,
        fit: "crop",
        q: 1,
        blur: 1
      })
    },
  }

}
